import * as React from 'react';
import Radium from 'radium';
import preload from 'redux-preload';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Button, Col, Grid } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { fetchWorkshops } from '../components/workshops/actions';

import Workshop from './workshop';

const RPT = React.PropTypes;

@preload(fetchWorkshops)
@connect(({ workshops: { workshopCategories } }) => ({ workshopCategories }))
@Radium
export default class WorkshopCategoryPage extends React.Component {
  static propTypes = {
    workshopCategories: RPT.arrayOf(RPT.shape({
      name: RPT.string.isRequired,
      workshops: RPT.arrayOf(RPT.shape)
    })).isRequired,
    match: RPT.shape({
      params: RPT.shape({
        id: RPT.string.isRequired
      })
    }).isRequired
  }

  render() {
    const { match: { params: { id } }, workshopCategories } = this.props;
    const category = workshopCategories.find(element => element.id === parseInt(id, 10));

    if (!category) return null;


    const proppedStyles = styles({ color: category.color, iconUrl: category.icon_url });

    return (
      <Grid>
        <Helmet>
          <title>{`Workshopy - ${category.name} - Stužák`}</title>
        </Helmet>
        <Col md={10} mdOffset={1} sm={12} style={{ padding: 0 }}>
          <h1>
            <img src={category.icon_url} alt={category.name} style={proppedStyles.image} />
            {category.name}
          </h1>
          <div style={{ margin: '10px 0' }}>
            <strong>Kategorie: </strong>
            { workshopCategories.map(workshopCategory => workshopCategory.workshops.length > 0 &&
              <LinkContainer className="category-button" to={`/workshopy/${workshopCategory.id}`} style={styles({ color: workshopCategory.color }).categoryButton} key={`link-${workshopCategory.id}`}>
                <Button bsSize="sm">
                  {workshopCategory.name}
                </Button>
              </LinkContainer>
            )}
          </div>
          {category.workshops.map(workshop =>
            <Workshop {...workshop} styles={proppedStyles} key={`workshop-${workshop.id}`} />
          )}
        </Col>
      </Grid>
    );
  }
}

const styles = ({ color, iconUrl }) => ({
  panel: {
    border: `1px solid ${color}`
  },
  heading: {
    backgroundColor: color,
    fontWeight: 'bold',
    color: '#fff'
  },
  body: {
    backgroundImage: `url(${iconUrl})`,
    backgroundPosition: 'bottom right',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 75
  },
  image: {
    width: 70,
    margin: '0 0 10px 0'
  },
  button: {
    margin: '5px 5px 0 0'
  },
  categoryButton: {
    backgroundColor: color,
    color: 'white',
    borderColor: color,
    margin: '5px',
    borderRadius: 3
  }
});



// WEBPACK FOOTER //
// ./src/browser/Feature/workshopcategorypage/index.jsx